import { useState } from "react";
import { handleKeyDown } from "../../utils/utils";

type MgpAlertProps  = {
    type: "success" | "danger" | "info" | "warning" | "general";
    message: string;
    hasCloseBtn?: boolean;
    onCloseErrHandler?: ()=> void
    isLongMessage?: boolean
}

export default function MgpMessage({type, message, hasCloseBtn, onCloseErrHandler, isLongMessage}: MgpAlertProps) {
    const [hideMessage, setHideMessage] = useState(false);
    if(hideMessage) {
        return <></>;
    }
     const onClickHandler = () => {
        setHideMessage(true);
        onCloseErrHandler?.()
     }
    return (
        <div className={"grid-flex va-center message " + type} style={{flexWrap: "nowrap"}} >
            {/* {isLongMessage ? <pre className="ta-left mr-lg" style={{width: "100%", textWrap:"wrap", lineHeight: "16px"}}>{message}</pre> : message } */}
            <span dangerouslySetInnerHTML={{__html: message}} style={{maxWidth: "100%", whiteSpace: 'pre-line'}}></span>
            {hasCloseBtn
            &&<span 
                className="closebtn" 
                onClick={onClickHandler} 
                role='button' 
                tabIndex={0} 
                onKeyDown={(e) => handleKeyDown(e)}>
                    &times;
            </span>}
        </div>

    );
} 